import React from 'react';
import {
  makeStyles,
  Card,
  Grid,
  Typography,
} from '@material-ui/core/';
import Contact from './ContactComponent';
import ContactForm from './ContactFormComponent';
import PickADate from './PickADateComponent';
import GoogleMaps from './GoogleMaps';

const useStyles = makeStyles(() => ({
  contactDiv: {
    display: 'flex',
    justifyContent: 'center',
    width: '100vw',
    padding: 15,
    zIndex: 1,
    boxShadow: '0px 1px 5px 0px black',
    overflow: 'visible',
  },
  marBot: {
    marginBottom: '10px',
  }
}));

function ContactPage() {
  const classes = useStyles();

  return (
    <Grid container >
      <Card className={classes.contactDiv} elevation={0}>
          <Contact />
      </Card>
      <GoogleMaps fullWidth={true} />
      <PickADate />
    </Grid>
  );
}

export default ContactPage;
